"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpotlightOverlay = void 0;

var _getVideoFrame = require("../../util/getVideoFrame");

var _react = _interopRequireWildcard(require("react"));

require("./SpotlightOverlay.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Spotlight Overlay
var SpotlightOverlay = function SpotlightOverlay(_ref) {
  var spotlightOverlayRef = _ref.spotlightOverlayRef,
      x = _ref.x,
      y = _ref.y,
      setX = _ref.setX,
      setY = _ref.setY,
      onChangeOverlayStyles = _ref.onChangeOverlayStyles,
      videoQuerySelector = _ref.videoQuerySelector,
      previewQuerySelector = _ref.previewQuerySelector;
  var moving = false;
  var localX = x;
  var localY = y;
  var startX = 0;
  var startY = 0;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      videoDidLoad = _useState2[0],
      setVideoDidLoad = _useState2[1];

  var doesEventHaveTouches = function doesEventHaveTouches(e) {
    return e.touches && e.touches.length > 0;
  };

  var handleVideoCanPlayEvent = function handleVideoCanPlayEvent() {
    if (!videoDidLoad) {
      setVideoDidLoad(true);
    }
  };

  var updateOverlayStyles = function updateOverlayStyles() {
    var newOverlayStyles = getOverlayStyles();
    onChangeOverlayStyles(newOverlayStyles);
  };

  var video = document.querySelector("".concat(videoQuerySelector, " video"));
  (0, _react.useEffect)(function () {
    if (video) {
      video.addEventListener('canplay', handleVideoCanPlayEvent);
    }

    return function () {
      if (video) {
        video.removeEventListener('canplay', handleVideoCanPlayEvent);
      }
    };
  }, [video]); // Listen to window resize events to scale spotlight appropriately

  (0, _react.useEffect)(function () {
    window.addEventListener('resize', updateOverlayStyles);
    return function () {
      window.removeEventListener('resize', updateOverlayStyles);
    };
  }, []);

  var onTouchStart = function onTouchStart(e) {
    console.log("onTouchStart");
    var overlay = document.querySelector("".concat(previewQuerySelector, " .SpotlightOverlay"));

    if (overlay) {
      overlay.classList.add("grab");
    }

    e.preventDefault();
    moving = true;

    if (doesEventHaveTouches(e)) {
      // Mobile
      var firstTouch = e.touches[0];
      startX = firstTouch.pageX;
      startY = firstTouch.pageY;
    } else {
      // Mouse (desktop)
      startX = e.pageX;
      startY = e.pageY;
    }
  };

  var onTouchMove = function onTouchMove(e) {
    console.log("onTouchMove");
    e.preventDefault(); // Get the video so we can extract its width/height

    var video = document.querySelector("".concat(videoQuerySelector, " video"));
    var videoWidth = video.offsetWidth / 1000;
    var videoHeight = video.offsetHeight / 1000;
    var newX;
    var newY;

    if (moving) {
      if (doesEventHaveTouches(e)) {
        var firstTouch = e.touches[0];
        var firstTouchX = firstTouch.pageX;
        var firstTouchY = firstTouch.pageY;
        var dx = (firstTouchX - startX) / videoWidth;
        var dy = (firstTouchY - startY) / videoHeight;
        startX = firstTouchX;
        startY = firstTouchY;
        newX = localX + dx;
        newY = localY + dy;
      } else {
        var moveX = e.pageX;
        var moveY = e.pageY;

        var _dx = (moveX - startX) / videoWidth;

        var _dy = (moveY - startY) / videoHeight;

        startX = moveX;
        startY = moveY;
        newX = localX + _dx;
        newY = localY + _dy;
      } // Cap the new values


      if (newX < 100) {
        newX = 100;
      }

      if (newX > 900) {
        newX = 900;
      }

      if (newY < 100) {
        newY = 100;
      }

      if (newY > 900) {
        newY = 900;
      }

      localX = newX;
      localY = newY;
      setX(localX);
      setY(localY);
      console.log(localX, localY);
    }
  };

  var onTouchEnd = function onTouchEnd(e) {
    console.log("onTouchEnd");
    var overlay = document.querySelector("".concat(previewQuerySelector, " .SpotlightOverlay"));

    if (overlay) {
      overlay.classList.remove("grab");
    }

    e.preventDefault();
    moving = false;
    setX(localX);
    setY(localY);
  };

  var getOverlayStyles = function getOverlayStyles() {
    var newOverlayStyles = {}; // Get the video so we can extract its width/height

    var videoSelector = "".concat(videoQuerySelector, " video");
    var video = document.querySelector(videoSelector);

    if (video) {
      var container = document.querySelector("".concat(previewQuerySelector, " .VideoPlayer"));
      var videoFrame = (0, _getVideoFrame.getVideoFrame)(container, video);
      var videoWidth = videoFrame.w;
      var videoHeight = videoFrame.h;
      var xpos = x / 1000 * videoWidth;
      var ypos = y / 1000 * videoHeight;
      var scale = y / 1000 * 1.75 + 0.25;
      scale = scale * (videoWidth / 2000);
      var bw = 8000 * scale;
      var bh = 8000 * scale;
      var bx = bw * -0.5 + xpos;
      var by = bh * -0.5 + ypos;
      bx += videoFrame.x;
      by += videoFrame.y;
      newOverlayStyles["backgroundSize"] = "".concat(bw, "px ").concat(bh, "px");
      newOverlayStyles["backgroundPosition"] = "".concat(bx, "px ").concat(by, "px");
      console.log(newOverlayStyles);
    }

    return newOverlayStyles;
  };

  (0, _react.useEffect)(function () {
    var newOverlayStyles = getOverlayStyles();
    onChangeOverlayStyles(newOverlayStyles);
  }, [x, y, videoDidLoad]);

  var addEventListeners = function addEventListeners() {
    setTimeout(function () {
      var overlay = spotlightOverlayRef.current;

      if (overlay) {
        // Desktop
        overlay.addEventListener("mousedown", onTouchStart);
        overlay.addEventListener("mousemove", onTouchMove);
        overlay.addEventListener("mouseup", onTouchEnd);
        overlay.addEventListener("mouseleave", onTouchEnd); // Mobile

        overlay.addEventListener("touchstart", onTouchStart);
        overlay.addEventListener("touchmove", onTouchMove);
        overlay.addEventListener("touchend", onTouchEnd);
        overlay.addEventListener("touchcancel", onTouchEnd);
      }
    }, 500);
  };

  var removeEventListeners = function removeEventListeners() {
    var overlay = spotlightOverlayRef.current;

    if (overlay) {
      // Desktop
      overlay.removeEventListener("mousedown", onTouchStart);
      overlay.removeEventListener("mousemove", onTouchMove);
      overlay.removeEventListener("mouseup", onTouchEnd);
      overlay.removeEventListener("mouseleave", onTouchEnd); // Mobile

      overlay.removeEventListener("touchstart", onTouchStart);
      overlay.removeEventListener("touchmove", onTouchMove);
      overlay.removeEventListener("touchend", onTouchEnd);
      overlay.removeEventListener("touchcancel", onTouchEnd);
    }
  }; // Initialize a few things


  (0, _react.useEffect)(function () {
    addEventListeners();
    return function () {
      removeEventListeners();
    };
  }, [spotlightOverlayRef]);
  return null;
};

exports.SpotlightOverlay = SpotlightOverlay;